module.exports = function (data) {
    return {
        event: 'BWSAURemoveFromFavourites',
        eventContext: {
            area: data.area,
            unitprice: data.product.SalePrice || data.product.Price,
            unitDisplay: data.product.Unit,
            productInfo: data.product.ProductData,
            isOnSpecial: data.product.IsSpecial ? 'true' : 'false'
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/atm-mapper-remove-from-favorite.js
 **/